import React, {useEffect, useState} from "react";
import Header from "../../components/Header.js";
import * as CampaignService from "../../services/CampaignService.js";
import * as AccountService from "../../services/AccountService.js";
import AllProductsList from "../../components/AllProductsList";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS, PRODUCT_TYPE} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import {getAllCampaigns, handleScrollPosition, isDeliveryOpen} from "../../util/common";
import analyticsLogEvent from "../../services/FirebaseService";
import {EventBus} from "../../util/EventBus";
import ScanQrToContinue from "../../components/ScanQrToContinue";
import OpenAppInBanner from "../../components/Banner/OpenAppInBanner";
import {getAllAvailableProductsHandler} from "../../handlers/HandlerProducts";

function TakeAwayMenu() {
    const hasBackButton = StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON) === "true";
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const shopName = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) ? StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME) : null;
    const userEmail = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL);
    const allowOrdering = shopDetails ? (typeof shopDetails.merchantConfig.allowOrdering !== "undefined" ? shopDetails.merchantConfig.allowOrdering : null) : false;


    const showDownloadApp = shopDetails ? (typeof shopDetails.merchantConfig.showDownloadApp !== "undefined" ? shopDetails.merchantConfig.showDownloadApp : null) : false;
    const [state, setState] = useState({
        allTagsAndProducts: [],
        allCampaigns: [],
        loyaltyCampaigns: [],
        shopDetails: null,
        continueInBrowser: StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) ? (StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) + "") === "true" : false,
    });

    useEffect(() => {
        document.body.classList.add("menu-page")
        return () => {
            document.body.classList.remove("menu-page")
        }
    }, []);


    useEffect(() => {
        if (!state.continueInBrowser) {
            if ((showDownloadApp === true || showDownloadApp === null) && (allowOrdering === null || allowOrdering)) {
                document.body.classList.add("blocked")
            }
        } else {
            document.body.classList.remove("blocked");
        }
        getPageContent().then(r => {
            handleScrollPosition();
            analyticsLogEvent("screen_view", {
                firebase_screen: FIREBASE_SCREEN_NAMES.TAKEAWAY,
                firebase_screen_class: FIREBASE_SCREEN_NAMES.TAKEAWAY
            });
        });

    }, []);


    const continueInBrowser = () => {
        StorageService.setItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER, "true");
        setState({
            ...state,
            continueInBrowser: true,
        })
        document.body.classList.remove("blocked");
    };


    const getPageContent = async () => {
        let shopDetails = null;
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {
            await AccountService.configApp();
            shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));
        } else {
            return;
        }

        const allTagsAndProducts = await getAllAvailableProductsHandler(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME), PRODUCT_TYPE.TAKEAWAY);

        const allCampaignsResponse = await getAllCampaigns(shopDetails.name);

        const loyaltyProductsPoints = await getLoyaltyProductsPoints(allCampaignsResponse);
        setState(prev => {
            return {
                ...prev,
                allCampaigns: filterCampaigns(allCampaignsResponse),
                loyaltyCampaigns: loyaltyProductsPoints,
                shopDetails: shopDetails,
                allTagsAndProducts: allTagsAndProducts
            };
        });
    }

    const getLoyaltyProductsPoints = async (allCampaigns) => {
        const loyaltyProductsPoints = {};
        for (let i = 0; i < allCampaigns?.length; i++) {
            const campaign = allCampaigns[i];
            if (campaign.name.indexOf("/loyalty/") > 1) {
                const campaignDetail = await getCampaignDetails(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME), campaign.name);
                if (campaignDetail.data.productStamps) {
                    campaignDetail.data.productStamps.forEach(productStamp => {
                        loyaltyProductsPoints[productStamp.pid] = productStamp.points;
                    });
                }
            }
        }
        StorageService.setItem(LOCALSTORAGE_ITEMS.LOYALTY_PRODUCTS_POINTS, JSON.stringify(loyaltyProductsPoints));
        return loyaltyProductsPoints;
    }

    const filterCampaigns = (allCampaigns) => {
        const filteredCampaigns = [];
        for (let i = 0; i < allCampaigns?.length; i++) {
            const campaign = allCampaigns[i];
            if (!campaign.link) { // if campaign is MENU/RESERVATIONS/TAKEAWAY DON'T RETURN IT
                filteredCampaigns.push(campaign);
            }
        }
        return filteredCampaigns;
    }

    const getCampaignDetails = async (shopName, promotionName) => {
        const response = await CampaignService.getCampaignDetails(shopName, promotionName);
        if (response.ok) {
            return response;
        } else {
            EventBus.dispatch("genericErrorMsg");
            console.log("Error retrieving campaign details");
        }
    }


    return (
        <>
            {
                shopName ?
                    <>

                        <Header
                            headerSize={HEADER_SIZE.MEDIUM}
                            shopDetails={state.shopDetails}
                            hasBackgroundImg={true}
                            headerTitle={state.shopDetails?.title}
                            hasModal={true}
                            hasBackBtn={hasBackButton}
                            hasDelivery={state.shopDetails?.merchantConfig.homeDelivery}
                            pickupAndDeliveryInfo={
                                {
                                    deliveryTime: state.shopDetails?.merchantConfig.weekDeliverySchedule?.estimatedDeliveryTime || null,
                                    pickupTime: state.shopDetails?.merchantConfig.weekPickupSchedule?.estimatedPickupTime || null,
                                    open: isDeliveryOpen(),
                                }
                            }
                            hasProfileBtn={true}
                            isTakeAwayMenu={true}
                        />

                        {userEmail &&
                        <AllProductsList
                            allCampaigns={((showDownloadApp === true || showDownloadApp === null) && (allowOrdering === true || allowOrdering === null)) ? state.allCampaigns : null}
                            allTagsAndProducts={state.allTagsAndProducts}
                            loyaltyCampaigns={state.loyaltyCampaigns}
                            hasCartBtn={false}
                            isTakeAwayMenu={true}
                        />}

                        {(showDownloadApp === true || showDownloadApp === null) && (allowOrdering === true || allowOrdering === null) ?
                            <OpenAppInBanner
                                continueInBrowser={state.continueInBrowser}
                                onContinueInBrowserClick={continueInBrowser}
                            />
                            : null}
                    </>
                    :
                    <ScanQrToContinue/>
            }
        </>

    );
}

export default TakeAwayMenu;
